//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { exportFile } from '@/api/downloadRequest'
export default {
  name: 'ProductViewList',
  data() {
    return {
      filterForm: {
        companyName: '',
        productName: '',
      },
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      tableData: [],
    }
  },
  created() {
    this.getFinanceProductList()
  },
  methods: {
    /**
     * @description:
     * @Author: quwandong
     * @Date: 2023-10-27 08:47:21
     */
    formatProductType({ productType }) {
      return {
        1: '农机保险',
        2: '养殖保险',
        3: '种植保险',
      }[productType]
    },
    //页码切换
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.getFinanceProductList()
    },
    // 获取列表数据
    async getFinanceProductList() {
      try {
        let { data } = await this.$http.insure.getInsureProductList({
          currentPage: this.pagination.currentPage,
          pageSize: this.pagination.pageSize,
          ...this.filterForm,
        })
        this.tableData = data.content
        this.pagination.total = data.recordTotal
      } catch (error) {
        console.log(error)
      }
    },
    // 导出
    handleToExport() {
      this.$http.insure
        .insureProductExport({ ...this.filterForm })
        .then((res) => {
          exportFile(res.data, '保险机构产品查询列表', 'xlsx')
        })
    },
    // 跳详情
    handleToDetail(row) {
      console.log('row', row)
      this.$router.push({
        path: '/insure/product/view/detail',
        query: {
          id: row.id,
          businessAddress: row.businessAddress,
        },
      })
    },
    // 查询
    handleFilter() {
      this.pagination.currentPage = 1
      this.getFinanceProductList()
    },
    //重置
    handleReset(formName) {
      this.$refs[formName].resetFields()
      setTimeout(() => {
        this.handleFilter()
      }, 500)
    },
    // 保险机构
    insureAssociate(key, cb) {
      if (key !== '') {
        this.loading = true
        this.$http.insure
          .queryInsurOreByKey({ key })
          .then(({ data }) => {
            this.loading = false
            // let arr = data.map( (item,index) => ({name:item,value:index}));
            cb(data) // 渲染回调
          })
          .catch((res) => {
            this.loading = false
          })
      }
    },
  },
}
